import React from 'react';
import { Box, Dialog, FormControl, FormControlLabel, Grid, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { translate } from 'react-jhipster';
import { Button } from 'reactstrap';

export const AddIbanDialog = ({
  openIBANModal,
  handleIBANModal,
  selectedIBANOption,
  handleIBANRadioChange,
  ibanValue,
  isValidIBANNumber,
  getIBANHelperText,
  handleIBANInputChange,
  bankNameValue,
  branchNameValue,
  handleIBANConfirm,
  isSubmittingIban,
}) => {
  return (
    <Dialog
      onClose={() => {
        if (!isSubmittingIban) {
          handleIBANModal('CLOSE');
        }
      }}
      open={openIBANModal}
      disableEscapeKeyDown={isSubmittingIban}
    >
      <Box sx={{ p: 4, width: 450 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
              {translate('comexApp.quotation.inputCustomerIban')}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <RadioGroup
                aria-labelledby="ibanNumber"
                value={selectedIBANOption}
                onChange={handleIBANRadioChange}
                name="radio-buttons-group"
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sx={{ display: 'flex', alignItems: 'flex-start' }}>
                    <Radio value="ibanNumber" checked={selectedIBANOption === 'ibanNumber'} onChange={handleIBANRadioChange} />
                    <Box sx={{ width: '100%' }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            fullWidth
                            label="IBAN Number"
                            placeholder="Eg. 123123123"
                            variant="filled"
                            size="small"
                            value={ibanValue}
                            error={isValidIBANNumber()}
                            helperText={getIBANHelperText()}
                            onChange={handleIBANInputChange}
                            disabled={selectedIBANOption !== 'ibanNumber'}
                            required={selectedIBANOption === 'ibanNumber'}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Bank Name"
                            variant="filled"
                            size="small"
                            value={bankNameValue}
                            disabled={true}
                            required={selectedIBANOption === 'ibanNumber'}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Branch Name"
                            variant="filled"
                            size="small"
                            value={branchNameValue}
                            disabled={true}
                            required={selectedIBANOption === 'ibanNumber'}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      value="later"
                      control={<Radio />}
                      label={<Typography variant="body2">{translate('comexApp.quotation.inputIbanLater')}</Typography>}
                      sx={{ m: 0 }}
                    />
                  </Grid>
                </Grid>
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid item xs={12} container spacing={2} justifyContent="flex-end">
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => {
                  handleIBANModal('CLOSE');
                }}
              >
                {translate('comexApp.quotation.cancelBtnLabel')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={handleIBANConfirm}
                disabled={selectedIBANOption === 'ibanNumber' && isValidIBANNumber()}
              >
                {translate('comexApp.quotation.confirmButton')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};
